import { createConfig } from "../config/config-utils"
import { ChallengesApp } from "./ChallengesApp"

export const SORTABALLS_CHALLENGES_CONFIG = createConfig({
  component: ChallengesApp,
  key: "sortaballs-challenges",
  label: "Sortaballs Challenges",
})